/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVectorRectangle: {
  name: 'vector-rectangle';
  data: string;
} = {
  name: 'vector-rectangle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2v6a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2H7a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2V9a2 2 0 0 1-2-2V5Zm4 4v6a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V9a2 2 0 0 1-2-2H7a2 2 0 0 1-2 2ZM4 7h1V5H3v2h1Zm0 10H3v2h2v-2H4Zm15 0h2v2h-2v-2Zm2-10h-2V5h2v2Z" fill="currentColor"/></svg>`,
};
